import React, { useState } from "react";
import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
//react-router
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

//toast
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

//axios
import axios from "axios";

import { UserContext } from "./context/UserContext";

import Footer from "./layout/Footer";
import Header from "./layout/Header";
import Routes from "./Routes";
import Customroutes from "./Customroutes";
const App = () => {
  const isAuthenticated = localStorage.getItem("token") ? true : false;
  const [user, setUser] = useState(null);
  var link = window.location.pathname;
  if (user === null && isAuthenticated) {
    setUser({ email: localStorage.getItem("user") });
  }

  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      const uid = localStorage.getItem("user");
      const ut = localStorage.getItem("ut");
      if (token) {
        config.baseURL = process.env.REACT_APP_BASE_URL;
        config.headers.common["token"] = token;
        config.headers.common["uid"] = uid;
        config.headers.common["ut"] = ut;
      } else {
        config.baseURL = process.env.REACT_APP_BASE_URL;
      }
      // config.headers['Content-Type'] = 'application/json';
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
  axios.interceptors.response.use((res) => {
    //console.log("res-url:" + res.request.responseURL);
  //    console.log("res-status:" + res.status);
  // console.log(res)
    if (res.data.status === "200") {
      return res;
    } else if (res.data.status === "100") {
      localStorage.setItem("token", res.data.token);
      return res;
    } else if (res.data.status === "401") {
      setUser(null);
      localStorage.clear();
      toast.error("Duplicate login. Please login again. !!!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      setTimeout(() => {
        window.location.href = "/Signin";
      }, 3000);
    } else if (res.data.status === "301") {
      //301 for something went wrong
      toast.error("Something went Wrong!!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      //   setTimeout(() => {
      //     window.location.href='/Signin'
      // }, 3000)
    }
  });
  return (
    <Router>
      <ToastContainer />
      <UserContext.Provider value={{ user, setUser }}>
        {/* <Header /> */}
        <Switch>
        <Route path='/Payment' component={Customroutes} />
        <Route path='/Eduplusnow' component={Customroutes} />
        <Route path='/StartExam' component={Customroutes} />
        <Route path='/' component={Routes} />
        </Switch>
        {/* <Routes /> */}
       

      </UserContext.Provider>
    </Router>
  );
}; 

export default App;
